import { Pipe, PipeTransform } from '@angular/core';
import { CommentPluginService } from './comment-plugin.service';

@Pipe({
    name: 'icon',
    standalone: false
})
export class IconPipe implements PipeTransform {
  public icons: any;

  constructor(private service: CommentPluginService) {
    this.icons = this.service.getIcons();
  }

  transform(id: string): any {
    let parsedId = parseInt(id);
    if (!Number.isInteger(parsedId)) {
      parsedId = null;
    }
    return this.service.getIcon(parsedId, this.icons);
  }
}
